const svgLocation =
	'<svg class="pin-svg" viewBox="0 0 200 290" width="200" height="290" xmlns="http://www.w3.org/2000/svg">\n' +
	'  <path class="pin-tail" d="M 38 160 L 96 270 C 96.8 272.2 102.4 272.6 104 270 L 162 160 Z" fill="#B40800" />\n' +
	'  <circle class="pin-disc" cx="100" cy="98" r="88" fill="#B40800" />\n' +
	'  <circle class="pin-inner" cx="100" cy="98" r="44" fill="#900600" />\n' +
	"</svg>";

const replaceLocationSVG = () => {
	const wrapSVG = document.querySelector(".contact-location-img");
	if (wrapSVG) {
		wrapSVG.innerHTML = svgLocation;
		const svg = wrapSVG.querySelector(".pin-svg");
		setTimeout(() => {
			svg.classList.add("active");
		}, 500);
	}
};

export { svgLocation, replaceLocationSVG };
